/** List users mapped to a tenant (tenant–user roles). */
export const tenantUserListSpec = {
    uri: '/t/[tenant]/user',
    method: 'POST',
};
